const NAG_GROUP_MAP = {
    "Move Quality": {
        "!": "Good move",
        "?": "Mistake",
        "!!": "Brilliant move",
        "??": "Blunder",
        "!?": "Interesting move",
        "?!": "Dubious move",
        "⭘": "Only move",
        "□": "Zugzwang",
    },
    "Position Evaluation": {
        "=": "Equal position",
        "∞": "Unclear position",
        "+/=": "Slight advantage for White",
        "=/+": "Slight advantage for Black",
        "+/-": "Moderate advantage for White",
        "-/+": "Moderate advantage for Black",
        "+-": "Decisive advantage for White",
        "-+": "Decisive advantage for Black",
    },
    "Strategic Elements": {
        "⟳": "With initiative",
        "↑": "With attack",
        "→": "With counterplay",
        "⇆": "With the idea of",
        "⨀": "Development advantage",
        "⊕": "Space advantage",
        "⊖": "Better pawn structure",
        "⊙": "Bishop pair advantage",
        "⊡": "Time trouble",
    },
    Other: {
        N: "Novelty",
        D: "Dubious novelty",
        Z: "Zugzwang",
        T: "Time control pressure",
    },
};
const COMMON_NAGS = ["!", "?", "!!", "??", "!?", "?!"];
const NAG_GROUPS = Object.entries(NAG_GROUP_MAP).reduce((acc, [group, nags]) => ({
    ...acc,
    [group]: Object.keys(nags),
}), {});
const NAG_VALUES = Object.values(NAG_GROUPS).flat();
const NAG_MAP = Object.values(NAG_GROUP_MAP).reduce((acc, groupNags) => {
    Object.keys(groupNags).forEach((nag) => {
        acc[nag] = groupNags[nag];
    });
    return acc;
}, {});
// Map numeric NAGs ($1, $2, etc.) to their symbolic equivalents
// Based on PGN standard: https://en.wikipedia.org/wiki/Portable_Game_Notation
const NUMERIC_TO_SYMBOLIC_NAG = {
    1: "!", // Good move
    2: "?", // Poor move / Mistake
    3: "!!", // Brilliant move
    4: "??", // Blunder
    5: "!?", // Interesting move
    6: "?!", // Dubious move
    7: "□", // Zugzwang
    8: "=", // Equal position
    9: "∞", // Unclear position
    10: "=", // Drawish position or even
    11: "=", // Equal chances, quiet position
    12: "=", // Equal chances, active position
    13: "∞", // Unclear position
    14: "+/=", // Slight advantage for White
    15: "=/+", // Slight advantage for Black
    16: "+/-", // White has a moderate advantage (same as $12)
    17: "-/+", // Black has a moderate advantage (same as $13)
    18: "+-", // White has a decisive advantage (same as $14)
    19: "-+", // Black has a decisive advantage (same as $15)
    20: "⟳", // With initiative
    21: "↑", // With attack
    22: "→", // With counterplay
    23: "⇆", // With the idea of
    24: "⨀", // Development advantage
    25: "⊕", // Space advantage
    26: "⊖", // Better pawn structure
    27: "⊙", // Bishop pair advantage
    28: "⊡", // Time trouble
    132: "N", // Novelty
    133: "D", // Dubious novelty
    140: "Z", // Zugzwang
    145: "T", // Time control pressure
};
/**
 * Converts a numeric NAG (e.g., "$1") to its symbolic equivalent (e.g., "!")
 * @param numericNag - The numeric NAG string (e.g., "$1", "$16")
 * @returns The symbolic NAG if found and mapped, or null if not mapped
 */
function convertNumericNagToSymbolic(numericNag) {
    // Extract the number from "$1", "$16", etc.
    const match = numericNag.match(/^\$(\d+)$/);
    if (!match)
        return null;
    const numericValue = parseInt(match[1], 10);
    const symbolicNag = NUMERIC_TO_SYMBOLIC_NAG[numericValue];
    return symbolicNag || null;
}
export { NAG_GROUP_MAP, COMMON_NAGS, NAG_GROUPS, NAG_VALUES, NAG_MAP, NUMERIC_TO_SYMBOLIC_NAG, convertNumericNagToSymbolic };
